import React from "react";

export default function CommonMsg({
    open,
    onClose,
    title = "Message",
    message,
}) {
    if (!open) return null;

    return (
        <div onClick={onClose} className="img-popup-design3">
            <div
                className="img-popup3"
                onClick={(e) => e.stopPropagation()} // prevent close when clicking inside
            >
                <button className="close-btn white" onClick={onClose}>
                    ×
                </button>

                <h4 className="f3 fs-xs-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 announement_title2 white">
                    {title}
                </h4>

                <div className="messageShow">
                    <p className="f2 fs-xs-16">{message}</p>
                </div>
            </div>
        </div>
    );
}